import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { ShowTourContext } from "../../../hooks/ContextStore";
import { useSelector } from "react-redux";

export default function ShowTour({description, videoUrl, fetchingModuleInfo}){
    const [video, setVideo] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    const [showTour, setShowTour]  = useContext(ShowTourContext);
    const { user } = useSelector((state) => state.auth);
    const role = user && user.data ? user.data.roles[0].name : null;

    const handleFetchVideo = async () => {
        let module_slug = "";
        if(location.pathname.includes('client-overview')){
            module_slug = "client-overview";
        }
        if(location.pathname.includes('attorney')){
            module_slug = "dashboard";
        }
        if(location.pathname.includes('basics')){
            module_slug = "basics";
        }
        if(location.pathname.includes('budget')){
            module_slug = "budget";
        }
        if(location.pathname.includes('children')){
            module_slug = "children";
        }
        if(location.pathname.includes('estate')){
            module_slug = "estate";
        }
        if(location.pathname.includes('timeline')){
            module_slug = "timeline";
        }
        // await Axios.get(`https://soil-hope.pockethost.io/api/collections/legal_videos/records?page=1&perPage=1&filter=module_slug%20%3D%20%22${module_slug}%22&skipTotal=1`)
        // .then(res => {
        //     console.log("POCKETBASE: ", res.data);
        // });
        // await Axios.get(`api/console/get_module/${module_slug}`)
        // .then(res => {
        //     if(role === 'client') {
        //         if(res.data.new_user_video_url !== ""){
        //             setVideo(res.data.new_user_video_url);
        //         } else {
        //             setVideo("");
        //         }
        //     } else {
        //         if(res.data.video_url !== ""){
        //             setVideo(res.data.video_url);
        //         } else {
        //             setVideo("");
        //         }
        //     }
        // });
    };

    const handleClose = () => {
        setIsVisible(false);
        setShowTour(false);
    };

    // useEffect(() => {
    //     // Only show if showTour is true and hasn't been shown before in this session
    //     if (showTour) {
    //         const sessionKey = `showTourShown_${location.pathname}`;
    //         const hasBeenShown = sessionStorage.getItem(sessionKey);
    //         if (!hasBeenShown) {
    //             setIsVisible(true);
    //             sessionStorage.setItem(sessionKey, 'true');
    //             handleFetchVideo();
    //         } else {
    //             setShowTour(false);
    //         }
    //     }
    // }, [showTour, location.pathname]);
    
    // if (!isVisible) {
    //     return null;
    // }

    return(
        <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100vh', width: '100%', left: '0', top: '0', zIndex: '9999', position: 'fixed', backdropFilter: 'blur(5px)', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
            <div className="card shadow-lg text-white position-relative" style={{minHeight: '300px', width: '700px', background: '#3699ff'}}>
                
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="mb-5 btn btn-sm btn-light position-absolute"
                    style={{ top: '10px', right: '10px', zIndex: '10000' }}
                >
                    Close
                </button>

                <div className="mt-5 card-body d-flex flex-column justify-content-center" style={{ minHeight: '200px' }}>
                    {fetchingModuleInfo && (
                        <div className="h5 text-center">
                            <div className="spinner-border text-light" role="status">
                            </div>
                        </div>
                    )}
                    {!fetchingModuleInfo && description && description !== "" && (
                        <div className="h5 text-center"
                            dangerouslySetInnerHTML={{
                                __html: description
                            }}>
                        </div>
                    )}
                    {!fetchingModuleInfo && videoUrl && videoUrl !== "" && (
                        <video src={videoUrl} autoPlay controls style={{ width: '100%', maxHeight: '700px', objectFit: 'contain' }} />
                    )}
                    {!fetchingModuleInfo && (!description || description === "") && (!videoUrl || videoUrl === "") && (
                        <div className="h5 text-center">
                            <p>
                                Welcome! This feature is now available to you. <br />
                                Explore the powerful capabilities and enhance your workflow. <br />
                                Get started with this amazing tool to boost your productivity. <br />
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};